import { z } from 'zod';

const filterSchema = z.object({
	propertyName: z.string().trim().min(1),
	op: z.string().trim().min(1),
	value: z.unknown().optional(),
});

const sortOrderSchema = z.object({
	field: z.string().trim().min(1),
	sort: z.enum(['asc', 'desc']),
});

export const hourlyAccountingParametersSchema = z.strictObject({
	filters: z.array(filterSchema).optional(),
	order: z.array(sortOrderSchema).optional(),
	sessionType: z.enum(['S2P', 'RESERVATION']).optional(),
	timezone: z.string().trim().min(1),
});

export type HourlyAccountingParameters = z.infer<typeof hourlyAccountingParametersSchema>;
